export enum ProductionKeyPerformanceIndicatorThresholdValueTypeEnum {
  PERCENT = 'percent',
  ABSOLUTE = 'absolute',
}
